var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHerald(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1542.3 1567.2",
    style: {
      enableBackground: "new 0 0 1542.3 1567.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A2A2A2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Rift_Herald"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "623.7,916.4 768.9,1138 914.2,916.4 768.9,671.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1133,0c72.3,174.3-1.2,354-35.9,422.9c-93.9-61.2-206.8-97-328.1-97C649,326,537.4,360.8,444.1,420.8 C409,350.3,337.7,172.5,409.3,0c0,0-436,299-408,815.9c0,0,96.5-3.7,175.7,83.9c0,1.6,0,3.2,0,4.8c0,319.6,265,578.6,592,578.6 s592-259.1,592-578.6v-0.2l0.1,0.2c80-92.6,180-88.7,180-88.7C1569,299,1133,0,1133,0z M1040.9,869c0,0-36,328.9-272,309.6 c-236,19.3-272-309.6-272-309.6c-44-267.1,272-238.2,272-238.2S1084.9,601.8,1040.9,869z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.1,1222.9L0,1367.8c0,0,132.6,151.4,311.7,199.4L211.1,1222.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1331.2,1222.9l211.1,144.9c0,0-132.5,151.4-311.7,199.4L1331.2,1222.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerald);
export default __webpack_public_path__ + "static/media/herald.9bbb9a006cd8b0b606f5216c827762c5.svg";
export { ForwardRef as ReactComponent };